var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM16.875 10C16.8766 11.6074 16.3121 13.1641 15.2805 14.3969L5.60313 4.71875C6.60703 3.88358 7.82804 3.35159 9.12326 3.18506C10.4185 3.01853 11.7344 3.22433 12.9169 3.77838C14.0994 4.33243 15.0997 5.21182 15.8006 6.31363C16.5016 7.41545 16.8743 8.69411 16.875 10ZM3.125 10C3.1234 8.39255 3.68793 6.83588 4.71953 5.60313L14.3969 15.2812C13.393 16.1164 12.172 16.6484 10.8767 16.8149C9.58152 16.9815 8.26565 16.7757 7.08313 16.2216C5.9006 15.6676 4.90033 14.7882 4.19937 13.6864C3.49841 12.5846 3.12575 11.3059 3.125 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabled);
export default __webpack_public_path__ + "static/media/disabled.9ff9f5f92454d38377b88d4481429375.svg";
export { ForwardRef as ReactComponent };